import React, { useEffect } from "react";
import HTMLContent from "../../../../../../common/html-content";
import { useTranslation } from "react-i18next";

const Notice = ({ notice, getNotice }) => {
  const { t, i18n } = useTranslation();
  const { language: currentLanguage } = i18n;

  useEffect(() => {
    if (Object.keys(notice).length === 0) {
      getNotice();
    }
  }, [notice]);

  const noticeField =
    currentLanguage.toUpperCase().substring(0, 2) === "EN"
      ? "text"
      : "text_" + currentLanguage.toUpperCase().substring(0, 2);

  const noticeText =
    notice === undefined || !notice.text ? null : (
      <div className="header-notice__message alert alert-info" role="status">
        <i
          className="header-notice__icon fa fa-bullhorn"
          aria-hidden="true"
        />
        <div className="header-notice__body">
          <HTMLContent content={notice[noticeField]} />
        </div>
      </div>
    );

  const cookiesWarning = !navigator.cookieEnabled ? (
    <p className="header-notice__message alert alert-danger" role="alert">
      {t("cookies-off")}
    </p>
  ) : null;

  const output =
    noticeText || cookiesWarning ? (
      <div className="header-notice">
        <div className="container header-notice__content">
          {noticeText}
          {cookiesWarning}
        </div>
      </div>
    ) : null;

  if (output === null) {
    return null;
  } else {
    return <div>{output}</div>;
  }
};

export default Notice;
